import createStore from './store';
import { FormattedDefaultTranscript } from '@/domains/transcript';

// TODO: @Hardik - To remove this store
export const fullTranscriptStore = createStore<FormattedDefaultTranscript>([]);
